/**
 * Product Gallery — Mobile Slider
 * Custom Element: <product-gallery>
 * Touch-swipe + prev/next buttons + dot pagination
 */
class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-slider-track]');
    this.slides = this.track ? [...this.track.children] : [];
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    this.dotsContainer = this.querySelector('[data-dots]');
    this.currentIndex = 0;
    this.touchStartX = 0;
    this.touchDeltaX = 0;

    this.tSlide = this.dataset.tSlide || 'Slide __N__';

    if (this.slides.length < 2) return;

    // Sprint 018-ε: `hidden` von Slides 2-N entfernen (waren im HTML gesetzt
    // um Flash-of-Unstyled-Content zu verhindern bevor CSS/JS greifen).
    this.slides.forEach((slide) => slide.removeAttribute('hidden'));

    this.buildDots();
    this.bindEvents();
    this.updateState();
  }

  buildDots() {
    if (!this.dotsContainer) return;
    this.dotsContainer.innerHTML = '';
    this.slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'product__slider-dot' + (i === 0 ? ' product__slider-dot--active' : '');
      dot.setAttribute('aria-label', this.tSlide.replace('__N__', i + 1));
      dot.addEventListener('click', () => this.goTo(i));
      this.dotsContainer.appendChild(dot);
    });
  }

  bindEvents() {
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex + 1));

    this.track.addEventListener('touchstart', (e) => {
      this.touchStartX = e.touches[0].clientX;
      this.touchDeltaX = 0;
    }, { passive: true });

    this.track.addEventListener('touchmove', (e) => {
      this.touchDeltaX = e.touches[0].clientX - this.touchStartX;
    }, { passive: true });

    this.track.addEventListener('touchend', () => {
      if (Math.abs(this.touchDeltaX) > 50) {
        this.goTo(this.currentIndex + (this.touchDeltaX < 0 ? 1 : -1));
      }
    });
  }

  goTo(index) {
    const max = this.slides.length - 1;
    this.currentIndex = Math.max(0, Math.min(index, max));
    this.updateState();
  }

  updateState() {
    const offset = -(this.currentIndex * 100);
    this.track.style.transform = `translateX(${offset}%)`;

    if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
    if (this.nextBtn) this.nextBtn.disabled = this.currentIndex === this.slides.length - 1;

    const dots = this.dotsContainer ? this.dotsContainer.children : [];
    [...dots].forEach((dot, i) => {
      dot.classList.toggle('product__slider-dot--active', i === this.currentIndex);
    });
  }
}

customElements.define('product-gallery', ProductGallery);
